// mitt is a js event bus library 
import mitt from 'mitt';
export default mitt();